import { Icon, StatusTag } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { getInvestmentRows } from '@modules/investor/utils/getInvestmentRows';
import { getInvestmentStatusVariant } from '@modules/investor/utils/getInvestmentStatusVariant';
import { mapMyInvestmentsToColumns } from '@modules/investor/utils/mapMyInvestmentsToColumns';
const InvestmentStatusCell = ({ row: { original } }) => {
    const { t } = useTranslation();
    const label = t(`financing.loan_status.${original.investmentStatus.toLowerCase()}`);
    const variant = getInvestmentStatusVariant(original.investmentStatus);
    if (!variant) {
        return <span className="body-s text-neutral-secondary-initial">{label}</span>;
    }
    return <StatusTag variant={variant} label={label} isFilledIcon={false}/>;
};
export const createInvestmentsTableConfig = (t) => {
    const getDetailsColumn = () => (<div className="flex justify-center w-full">
            <Icon name="chevron_forward" size="sm"/>
        </div>);
    const columns = [
        {
            header: t('financing.investing_page_table.id'),
            accessorKey: 'id',
            size: 56,
            sortable: true,
        },
        {
            header: t('financing.investing_page_table.asked_amount'),
            accessorKey: 'loanAmount',
            sortable: true,
        },
        {
            header: t('financing.investing_page_table.loan_purpose'),
            accessorKey: 'loanPurpose',
        },
        {
            header: t('financing.investing_page_table.period'),
            accessorKey: 'loanPeriod',
            sortable: true,
        },
        {
            header: t('financing.investing_page_table.roi'),
            accessorKey: 'roi',
            sortable: true,
        },
        {
            header: t('financing.investing_page_table.status'),
            accessorKey: 'investmentStatus',
            cell: InvestmentStatusCell,
        },
        {
            header: t('financing.investing_page_table.funding_progress'),
            accessorKey: 'fundingProgress',
        },
        {
            header: '',
            accessorKey: 'details',
            cell: getDetailsColumn,
            size: 68,
        },
    ];
    return {
        columns,
        mapDataToColumns: mapMyInvestmentsToColumns,
        getMobileRows: getInvestmentRows,
        isInvestment: true,
    };
};
